"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const AdjustmentDayOffColumnProps = [
    {
        show: true,
        field: 'date_off',
        title: 'Date',
        width: '150',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMYYYY
    },
    {
        show: true,
        field: 'event_day',
        title: 'Event',
        width: '250',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '150',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '150',
        filter: 'text',
    }
];
exports.default = AdjustmentDayOffColumnProps;
